import { AccountSecurityView } from './account-security-view';
import { useAccountSecurity } from './use-account-security';

export const AccountSecurityPage = () => <AccountSecurityView {...useAccountSecurity()} />;

export default AccountSecurityPage;
